import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
    providedIn: 'root',
})
export class TagTiersService {
    constructor(private http: HttpClient) { }

    tags(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tagTiers:tags',
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    get(code: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tagTiers:get',
            params: {
                code: code,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    getTiersTypeTags(type_id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tagTiers:getTiersTypeTags',
            params: {
                type_id: type_id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    };

    getTiersTags(tiers_id: string, options: any = []): Observable<JSONRpcResponse> {

        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tagTiers:getTiersTags',
            params: {
                tiers_id: tiers_id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

    }
    addTagToTiers(tag_id: string, tiers_id: string, options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tagTiers:addTagToTiers',
            params: {
                tag_code: tag_id,
                tiers_id: tiers_id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    removeTagFromTiers(tag_id: string, tiers_id: string, options: any = []): Observable<JSONRpcResponse> {

        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tagTiers:removeTagFromTiers',
            params: {
                tag_id: tag_id,
                tiers_id: tiers_id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

    }

    thisTypeHasActiveTags(type_id: string, options: any = []): Observable<JSONRpcResponse> {

        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tagTiers:thisTypeHasActiveTags',
            params: {
                type_id: type_id,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

    }
    getOrigineTags(options: any = []): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tagTiers:getOrigineTags',
            params: {
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

    }
}
